export default __webpack_public_path__ + "ui/assets/img/checked-20.svg";